export default __webpack_public_path__ + "static/media/3103.a0eb3617.jpg";